/**
 * REPORT-SCREENSHOT-HISTORY.WIDGET.TSX
 * Preview of the history widget
 */
import Space from "@/components/space"
import DashboardHistoryWidget from "./dashboard-history.widget"
import { Topic } from "@/redux/topic.types"

interface OwnProps {
  isFullWidth?: boolean
  currentTopics: Topic[]
}

function ReportScreenshotHistoryWidget(props: OwnProps) {
  return (
    <div
      className="flex"
      style={{
        transform: "scale(0.45)",
        transformOrigin: "top left",
        marginTop: -20
      }}>
      <Space />
      <DashboardHistoryWidget isPreview currentTopics={props.currentTopics} isReport />
      <Space />
    </div>
  )
}

export default ReportScreenshotHistoryWidget
